module.exports = __webpack_public_path__ + "img/practice_03.48aa31ed.jpeg";